"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatOrdinalParts = void 0;
var OrdinalPeriodIntl;
(function (OrdinalPeriodIntl) {
    OrdinalPeriodIntl["MonthOfYear"] = "month";
    OrdinalPeriodIntl["DayOfMonth"] = "day";
    OrdinalPeriodIntl["NonOrdinalPeriod"] = "";
})(OrdinalPeriodIntl || (OrdinalPeriodIntl = {}));
var OrdinalPeriodIntlTypes = [
    OrdinalPeriodIntl.DayOfMonth,
    OrdinalPeriodIntl.MonthOfYear,
];
var localeOrdinalNumber = function (locale, num, period) {
    if (period === void 0) { period = OrdinalPeriodIntl.NonOrdinalPeriod; }
    // These needs to be filled out by talking to our clients...
    // I attempted to grab these from moment.js but after speaking to a few
    // of the native speakers of the languages in the office moment.js's
    // are too formal for us, or don't reflect current usage...
    var supportedOrdinalLocales = {
        en: function (n) {
            if ([11, 12, 13].includes(n)) {
                return n + 'th';
            }
            var firstDigit = n % 10;
            switch (firstDigit) {
                case 1:
                    return n + 'st';
                case 2:
                    return n + 'nd';
                case 3:
                    return n + 'rd';
                default:
                    return n + 'th';
            }
        },
        fr: function (n, timePeriod) {
            switch (timePeriod) {
                default:
                case OrdinalPeriodIntl.DayOfMonth:
                    return n + (n === 1 ? 'er' : '');
                case OrdinalPeriodIntl.MonthOfYear:
                    return "" + n;
            }
        },
        de: function (n) { return "" + n; },
        es: function (n) { return "" + n; },
    };
    var lowerCaseLocale = locale.toLowerCase();
    var localesToTry = [lowerCaseLocale];
    if (locale.includes('-')) {
        localesToTry.push(lowerCaseLocale.split('-')[0]);
    }
    for (var _i = 0, localesToTry_1 = localesToTry; _i < localesToTry_1.length; _i++) {
        var loc = localesToTry_1[_i];
        var ordinalFunc = supportedOrdinalLocales[loc];
        if (ordinalFunc) {
            return ordinalFunc(num, period);
        }
    }
    return num.toString();
};
exports.formatOrdinalParts = function (locale, parts, options) {
    return parts.map(function (p) { return ({
        type: p.type,
        value: OrdinalPeriodIntlTypes.includes(p.type) &&
            options[p.type] === 'numeric'
            ? localeOrdinalNumber(locale, parseInt(p.value, 10), p.type)
            : p.value,
    }); });
};
//# sourceMappingURL=ordinal.js.map